<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import PageLayout from 'dashboard/components-next/arrowsAi/PageLayout.vue';
import VerticalTabs from 'dashboard/components-next/vertical-tabs/VerticalTabs.vue';

defineProps({
  heading: { type: String, required: true },
  description: { type: String, default: '' },
});

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const tabs = computed(() => [
  {
    id: 'arrows_ai_assistants_settings',
    icon: 'i-lucide-settings',
    label: t('ARROWS_AI.SETTINGS.BASIC.TITLE'),
  },
  {
    id: 'arrows_ai_assistants_settings_system',
    icon: 'i-lucide-sliders-horizontal',
    label: t('ARROWS_AI.SETTINGS.SYSTEM.TITLE'),
  },
  {
    id: 'arrows_ai_assistants_settings_schedule',
    icon: 'i-lucide-calendar-clock',
    label: t('ARROWS_AI.SETTINGS.SCHEDULE.TITLE'),
  },
  {
    id: 'arrows_ai_assistants_settings_limits',
    icon: 'i-lucide-shield-check',
    label: t('ARROWS_AI.SETTINGS.LIMITS.TITLE'),
  },
  {
    id: 'arrows_ai_assistants_settings_reply_style',
    icon: 'i-lucide-message-square-text',
    label: t('ARROWS_AI.SETTINGS.REPLY_STYLE.TITLE'),
  },
]);

const activeTab = computed({
  get: () => route.name,
  set: name =>
    router.push({
      name,
      params: {
        accountId: route.params.accountId,
        assistantId: route.params.assistantId,
      },
    }),
});
</script>

<template>
  <PageLayout :header-title="t('ARROWS_AI.SETTINGS.HEADER')">
    <VerticalTabs
      v-model="activeTab"
      :tabs="tabs"
      content-class="max-w-[45rem] pb-8"
    >
      <template #[activeTab]>
        <div class="flex flex-col w-full gap-6">
          <div>
            <h2 class="text-base font-medium text-n-slate-12">{{ heading }}</h2>
            <p v-if="description" class="mt-1 text-sm text-n-slate-11">
              {{ description }}
            </p>
          </div>
          <slot />
        </div>
      </template>
    </VerticalTabs>
  </PageLayout>
</template>
